// @flow
import React, { Component, Fragment } from "react";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Modal from "elevate-ui/Modal";

import CalculatorIcon from "elevate-ui-icons/Calculator";
import ArrowDropDown from "elevate-ui-icons/ArrowDropDown";
import Home from "elevate-ui-icons/Home";

import mortgageJs from "../common/MortgageCalculator/mortgage-calculator";
import Calculator from "../common/Calculator";

type $Props = {
  address: string,
  classes: Object,
  price: number,
  datastoreProviderId: number | string,
};
type $State = {
  showCalculator: boolean,
};

class Mortgage extends Component<$Props, $State> {
  constructor(props) {
    super(props);

    this.state = {
      showCalculator: false,
    };
  }

  handleModal = () => {
    this.setState((state) => ({ showCalculator: !state.showCalculator }));
  };

  render() {
    const { address, classes, price, datastoreProviderId } = this.props;
    const { showCalculator } = this.state;
    const downPayment = price * 0.2;
    const monthlyPayment = mortgageJs.calculatePayment(
      price,
      downPayment,
      0.045,
      360,
      0.012,
      0.0013,
      0.01,
      true,
      0.2,
      100,
      datastoreProviderId
    );
    const formattedPayment = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(monthlyPayment.total);
    return (
      <Fragment>
        <div className={classes.root} id="ref__mortgage-calculator">
          <button
            onClick={this.handleModal}
            type="button"
            className={classes.mortgageButton}
          >
            <CalculatorIcon style={{ marginLeft: "4px" }} color="#60686f" />
            <ArrowDropDown />
          </button>
          <div className={classes.textContainer}>
            <Typography type="subHeading2">Est. Mortgage</Typography>
            <Typography type="heading5" gutterBottom>
              {monthlyPayment && formattedPayment}/mo
            </Typography>
          </div>
        </div>
        <Modal
          showFooter={false}
          confirmAction={() => null}
          title={address}
          titleIcon={<Home />}
          visible={showCalculator}
          toggleModal={this.handleModal}
        >
          <Calculator
            totalPrice={price}
            withPaper={false}
            datastoreProviderId={datastoreProviderId}
          />
        </Modal>
      </Fragment>
    );
  }
}

const styles = (theme) => ({
  root: {
    display: "flex",
    flexShrink: "0",
    paddingTop: theme.spacing.unit * 0.75,

    [theme.breakpoints(1000)]: {
      paddingTop: theme.spacing.unit,
    },
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",

    [theme.breakpoints(1000)]: {
      textAlign: "right",
    },
  },
  mortgageButton: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: theme.spacing.unit * 0.75,
    padding: "2px",
    height: "40px",
    backgroundColor: theme.colors.white,
    border: `2px solid ${theme.colors.gray["200"]}`,
    borderRadius: theme.globalBorderRadius,
    color: theme.colors.gray["800"],
    transition: "background-color 250ms ease",
    "&:hover": {
      backgroundColor: theme.colors.gray["100"],
    },
    order: "2",

    [theme.breakpoints(1000)]: {
      order: "0",
      flexDirection: "row",
      padding: "0px",
      marginRight: theme.spacing.unit * 0.75,
    },
  },
});

export default withStyles(styles)(Mortgage);
